import { getJson } from "./networkService";

export async function getOrders(fromDate,toDate,accountNumber, page, filter) {  
  return getJson(`/orders/${accountNumber}?page=${page}&filter=${filter}&fromDate=${fromDate}&toDate=${toDate}`);
}

export async function getOrder(orderNumber) {
  return getJson(`/orders/order/${orderNumber}`);
}
